import { Component, ElementRef, Injector, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';
import { DialogService } from '../../dialog/dialog.service';
import { AlertsService } from '../../../services/alerts.service';
import { AsideBarService } from '../../../services/asideBar.service';
import { FilterService } from '../../../services/filter.service';
import { LoaderService } from '../../../services/loader.service';
import { ModalService } from '../../../services/modal.service';
import { SmartModalService } from '../../../services/smart-modal.service';
import { UtilService } from '../../../services/util.service';
import { AppService } from '../../../shared/services/app.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { BaseService } from '../../../shared/services/base.service';
import { PreferenceService } from '../../../shared/services/preference.service';
import { PrintService } from '../../../shared/services/print.service';
import { RolePermissionService } from '../../../shared/services/role-permission.service';
import { StorageService } from '../../../shared/services/storage.service';
import _moment from 'proxies/dayjs';
import { CommonViewerComponent } from '../common-viewer/common-viewer.component';
import { CommunicationService } from 'src/modules/base/services/communication.service';
const moment = _moment

@Component({
    selector: 'app-s3-viewer',
    templateUrl: '../common-viewer/common-viewer.component.html',
    styleUrls: ['../common-viewer/common-viewer.component.scss'],
    standalone: false
})
export class S3ViewerComponent extends CommonViewerComponent implements OnInit {

  constructor(
    public baseService: BaseService,
    public elementRef: ElementRef,
    public ngZone: NgZone,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public loader: LoaderService,
    public appService: AppService,
    public asideBarService: AsideBarService,
    public preferenceService: PreferenceService,
    public alerts: AlertsService,
    public modalService: ModalService,
    public smartModalService: SmartModalService,
    public dialogService: DialogService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public utilService: UtilService,
    public filterService: FilterService,
    public communicationService: CommunicationService,
    public rolePermissionService?: RolePermissionService,
    public injector?: Injector,
    public dialogConfig?: DialogConfig,
    public dialogRef?: DialogRef,
    public printService?: PrintService
  ) { super(baseService, elementRef, ngZone,route, storageService, loader, appService, asideBarService, preferenceService, alerts, modalService, smartModalService, dialogService, router, authenticationService, utilService, filterService, communicationService,rolePermissionService, injector, dialogConfig, dialogRef, printService)}

  ngOnInit() {
    // this.newPrintEnable = false;
    // this.templateChecked = false;
    // this.pagination.page_size = 5;
    super.checkCardFieldConfig();
    this.closeBtnSubscription.add(this.asideBarService.closeBtnClicked_val.subscribe((res)=>{
      if(res){
        this.hideEditForm = false;
      }
    }))
    this.bannerJson = this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.bannerJson ? this.dialogConfig.data.bannerJson : this.bannerJson;
    if (this.resource == undefined)
      this.resource = this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.resource ? this.dialogConfig.data.resource : this.resource;
    if (this.route.snapshot.params.action && this.route.snapshot.params.action == 'view')
      this.viewOnly = true;
    if (this.route.snapshot.data.showHistory != undefined && this.route.snapshot.data.showHistory == false)
      this.showHistory = false
    this.currentResource = (this.resource != undefined && this.resource.resource != undefined) ? this.resource.resource : (this.route.snapshot.data.resource != undefined ? this.route.snapshot.data.resource : "")
    this.checkCopyRule();
    this.currentData.ehr_view = false;
    this.currentData.scrollToView = false; // config to scroll grid Data into view
    this.currentData.componentType = 's3_viewer';
    this.currentData.viewerDownload  = true
    this.currentData.viewerPrint  = true
  
    if (JSON.parse(localStorage?.currentUser) != undefined && JSON.parse(localStorage?.currentUser) != "" && JSON.parse(localStorage?.currentUser).user_id && (this.currentResource == 'template_assessment' || this.currentResource == 'template_assessment_op' || this.currentResource == 'template_assessment_final')) {
      this.currentData['show_confidential'] = this.rolePermissionService.checkAccessPermission('confidential_true', this.currentResource)
      this.baseService.get("GET_BY_ID", "id:" + JSON.parse(localStorage?.currentUser).user_id, "account_user", "account-management").subscribe((res) => {
        if (res && res.resource && res.resource[0]) {
          let obj = {
            confidentialDepartmentId: res.resource[0].department_id,
            confidentialDepartment: res.resource[0].department_name
          }
          this.currentDoctor = obj
        } else {
          let obj = {
            confidentialDepartmentId: "",
            confidentialDepartment: ""
          }
          this.currentDoctor = obj
        }
        this.initialize()
      })
    } else {
      this.initialize()
    }
  }


  initialize(){
    if (this.currentResource) {
      this.baseService.getResourceDef(this.currentResource, (resouceDef) => {
        this.onlyEditForDischargePatientList(resouceDef)
        this.currentData['fields'] = resouceDef.list.fields;
        this.currentData['APIResource'] = resouceDef.list.APIresource;
        this.currentData['resouceDef'] = resouceDef;
        this.currentData['filterBlock'] = resouceDef.list.filter;
        if (resouceDef && resouceDef.list && resouceDef.list.complex_search && this.currentData['resouceDef'] && this.currentData['resouceDef']['config']) {
          this.currentData['resouceDef']['config']['complex_search'] = resouceDef.list.complex_search
        }
        this.currentData.document_type = resouceDef && resouceDef.config && resouceDef.config.document_type ? resouceDef.config.document_type: undefined;
        this.currentData.ehr_view_button = resouceDef && resouceDef.config && resouceDef.config.ehr_view ? resouceDef.config.ehr_view : false;
        this.currentData.scrollToView = resouceDef && resouceDef.config && resouceDef.config.scrollToView ? resouceDef.config.scrollToView : false;
        this.currentData.secondary_uhid_default = resouceDef && resouceDef.config && resouceDef.config.secondary_uhid_default ? resouceDef.config.secondary_uhid_default : false;
        this.currentData.ehr_view = resouceDef && resouceDef.config && resouceDef.config.ehr_view_default ? resouceDef.config.ehr_view_default : false;
        this.currentData.secondary_uhid = resouceDef && resouceDef.config && resouceDef.config.secondary_uhid ? resouceDef.config.secondary_uhid : false;
        this.currentData.save_filter = resouceDef && resouceDef.config && resouceDef.config.save_filter ? resouceDef.config.save_filter : false;
        this.currentData.viewerDownload  = (resouceDef && resouceDef.config && resouceDef.config.viewerDownload == false) ? false  : true;
        this.currentData.viewerPrint  = (resouceDef && resouceDef.config && resouceDef.config.viewerPrint == false) ? false  : true;
        this.baseService.setTitleFromResouceDef(resouceDef, 'LIST');
        if (resouceDef.config != undefined && resouceDef.config.config_check != undefined) {
          this.checkAdendumHistoryConfig(resouceDef.config.config_check);
        } else {
          this.currentData.addendum_history_show = true;
        }
        if (this.authenticationService.getUserType() == 'patient') {
          let data = { args: "id:" + this.authenticationService.getCurrentUser().user_id }
          this.baseService.getData(data, "", "patient", "patient-registration", "GET_BY_ID").toPromise().then(res => {
            if (res) {
              this.currentData['cardData'] = res.resource[0];
              this.currentData['cardData']['patient_id'] = this.appService.getCurrentUser().user_id
            }
            this.saveUserDepartment()
            this.getHistory(this.currentData['APIResource'].datasource);
          })
        } else {
          this.storageService.getSessionStorageData("currentData", (data) => {
            if (data) {
              this.currentData['cardData'] = data;
              // this.currentData['cardData']['patient_id'] = this.appService.getCurrentUser().user_id 
            }
            this.saveUserDepartment()
            if (this.currentData['filterBlock'] == undefined || (this.currentData['filterBlock'] != undefined && (this.currentData['filterBlock'].default_filter == undefined || this.currentData['filterBlock'].default_filter == false)))
              this.filterClick(this.search);
          });
        }
      });
    } else if (this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.showImageViewer) {
      this.currentData = {};
      this.showImageView = true;
      this.onClickSideList(this.dialogConfig.data.config);
    }
    this.config['filterAr'] = []
    if (this.currentData['filterBlock'] != undefined && this.currentData['filterBlock'].quick_filters != undefined)
      this.config['filterAr'] = this.currentData['filterBlock'].quick_filters
    this.config['filterConfig'] = {}
    if (this.config.filterAr && this.config.filterAr.length > 0) {
      this.config.filterAr.forEach(el => {
        if (el.selected != undefined && el.selected) {
          this.default_quick_filter.selected = true
          this.default_quick_filter.data = el
        }
      });
    }
    this.config['save_filter'] = this.currentData.save_filter
    if (this.currentResource != undefined) {
      this.config.saveKey = this.currentResource + "_list_config";
      this.applyTableConfig(() => {
        this.getSavedFilter();
      });
    }
    //Gets config for pin/password required or not
    this.baseService.get("GET_CONFIG", "module_code:emr,config_code:pin_required", "facility_config_mapping", "facility-management").subscribe(data => {
      if (data.errCode == 0 && data.resource.length > 0) {
        if (data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.includes('e_prescription')) {
          this.isPinRequired = true;
        } else {
          this.isPinRequired = false;
        }
      } else {
        this.isPinRequired = false;
      }
    });
    this.getCurrentDepartment();
  }

  getHistory(datasource?, callback = null) {
    super.getHistory(datasource, (res) => {
      if(res && res.resource && res.resource.length > 0){
        this.loader.hideSpinner();
        if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.getter_list_key != undefined) {
          this.currentData['whole_list'] = res.resource[0][this.currentData['resouceDef'].config.getter_list_key];
          if(res.resource[0].uhId != undefined){
            this.currentData.whole_list.forEach(element => {
              element.uhId = res.resource[0].uhId;
            });
          }
          if(this.currentData['whole_list'].length > 10){
            let whole_list = JSON.parse(JSON.stringify(this.currentData['whole_list']));
            this.currentData['list'] = whole_list.splice(this.pagination.page_no * 10, this.pagination.page_size);
          }else if(this.currentData['whole_list'].length > 0){
            this.currentData['list'] = this.currentData['whole_list'];
          }else{
            this.currentData['list'] = undefined;
            this.currentData.selectedList = undefined;
          }
          this.currentData['count'] = this.currentData['whole_list'].length;
        }
        if(this.currentData['whole_list'].length > 0)
          this.hitSecondaryDataSource(this.currentData['list'][0]);
      }
    });
  }


  goPrev() {
    if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.getter_list_key != undefined) {
      if (this.pagination['page_no'] && this.pagination['page_no'] != 0 && this.currentData['count'] > this.pagination['page_no']) {
        this.pagination['page_no'] = this.pagination['page_no'] - 1;
        this.filter.filter = this.filter.pseudoFilter == '' ? this.filter.filter : this.filter.pseudoFilter;
        let whole_list = JSON.parse(JSON.stringify(this.currentData['whole_list']));
        this.currentData['list'] = whole_list.splice(this.pagination.page_no * 10, this.pagination.page_size);
        this.hitSecondaryDataSource(this.currentData['list'][0]);
      }
    }else{
      super.goPrev();
    }
  }

  goNext() {
    if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.getter_list_key != undefined) {
      this.pagination['page_no'] = this.pagination['page_no'] + 1;
      this.filter.filter = this.filter.pseudoFilter == '' ? this.filter.filter : this.filter.pseudoFilter;
      let whole_list = JSON.parse(JSON.stringify(this.currentData['whole_list']));
      this.currentData['list'] = whole_list.splice(this.pagination.page_no * 10, this.pagination.page_size);
      this.hitSecondaryDataSource(this.currentData['list'][0]);
    }else{
      super.goNext();
    }
  }
  
  // getHistory(datasource?, type?) {
  //   this.loader.showSpinner();
  //   var args = '';
  //   var filter = '';
  //   var search = '';
  //   if (datasource && datasource.search)
  //     search = datasource.search
  //   if (datasource == undefined) {
  //     datasource = this.checkGetAPI();
  //   }
  //   if (datasource) {
  //     if (datasource.args != undefined && datasource.args.indexOf('!!!') != -1) {
  //       // if (this.currentData['cardData'])
  //       //   this.currentData['cardData']['orderingDepartmentId'] = this.currentData['cardData']['patientType'] == 'OP' ? this.currentData['cardData']['department_id'] : this.currentData['cardData']['treating_department_id'];//added for confidential temp
  //       args = this.baseService.buildDyanamicStr(datasource.args, { data: this.currentData['cardData'] })
  //     }
  //     else
  //       args = datasource.args
  //     //need to remove if we discard view screen
  //     if (datasource.filter != undefined && datasource.filter.indexOf('!!!') != -1) {
  //       filter = this.baseService.buildDyanamicStr(datasource.filter, { data: this.currentData['cardData'] })
  //     }
  //     else
  //       filter = datasource.filter ? datasource.filter : ''
  //     var data = {
  //       args: args,
  //       search: (search != undefined && search != "") ? search : this.search,
  //       page_no: this.pagination.page_no,
  //       page_size: this.pagination.page_size,
  //       filter: filter + (filter && this.filter && this.filter.filter ? "," : '') + this.filter.filter
  //     }
  //     if(type !=  undefined && type == 'next'){
  //       let re_data = this.currentData.s3List[this.currentData.s3List.length -1];
  //       data['page_no'] = re_data.extra_data ? re_data.extra_data.path: re_data.path;
  //     }
  //     if (this.currentData.secondary_uhid_default) {
  //       data['args'] += "," + "secondary_uhid:true"
  //     }
  //     if (this.currentData.ehr_view)
  //       data['read_scope_level'] = 'account';
  //     else if (data['read_scope_level'] != undefined)
  //       delete data['read_scope_level'];
  //     if(data['read_scope_level'] && datasource.ehr_filter){
  //       data['filter'] = this.baseService.buildDyanamicStr(datasource.ehr_filter, { data: this.currentData['cardData'] })
  //     }
  //     this.baseService.getData(data, "", datasource.resource, datasource.application, datasource.query_id || datasource.queryId).subscribe(res => {
  //       this.loader.hideSpinner();
  //       this.currentData.s3List = res.resource;
  //       if (this.currentData['resouceDef'].config != undefined && this.currentData['resouceDef'].config.decorator != undefined) {
  //         if (!this.currentData.decorator || (this.currentData.decorator && this.currentData.decorator.className != undefined && this.currentData.decorator.className != this.currentData['resouceDef'].config.decorator))
  //           this.currentData.decorator = this.baseService.initDecorator(this.currentData['resouceDef'].config.decorator, this.route);
  //       }
  //       if (this.currentData.decorator.beforeSaveList) {
  //         this.currentData.decorator.beforeSaveList(this.baseService, res.resource, (cb) => {
  //           res.resource = cb;
  //         })
  //       }
  //       if(this.currentData['list'] == undefined)
  //         this.currentData['list'] = [];
  //       if(res.resource && res.resource.length > 0){
  //         res.resource.forEach(element => {
  //           if (element && element.extra_data) {
  //             element.extra_data.status = 'final';
  //            // element.extra_data.g_creation_time = this.utilService.convertExponentToDate(element.extra_data.g_creation_time);
  //             element.extra_data.uhId = this.currentData.cardData && this.currentData.cardData.uhId ? this.currentData.cardData.uhId : '';
  //             element.extra_data.encounter_id = this.currentData.cardData && this.currentData.cardData.encounter_id ? this.currentData.cardData.encounter_id : '';
  //             this.currentData['list'].push(element.extra_data);
  //           }
  //         });
  //         // if(res.resource.length < this.pagination.page_size){
  //           this.callMongoAPI();
  //         // }
  //       }else if(res.resource == undefined || (res.resource && res.resource.length < this.pagination.page_size)){
  //         this.callMongoAPI();
  //       }else{
  //         this.currentData['list'] = this.currentData['list'].sort(function(a, b){
  //           return b.g_creation_time - a.g_creation_time;
  //         })
  //       }
  //       this.currentData.count  = this.currentData['list'].length;
  //       this.currentData.required_data = this.currentData['list'];
  //       this.checkExpressionForAdd();
  //       if (this.route.snapshot.queryParams.activePrescriptionId != undefined && res.resource && res.resource.length > 0 && !this.utilService.isMobile()) {
  //         let activeValueindex = res.resource.indexOf(res.resource.find(x => x.id == this.route.snapshot.queryParams.activePrescriptionId));
  //         this.activeValue = (activeValueindex == undefined ? 0 : activeValueindex);
  //         this.hitSecondaryDataSource(res.resource[this.activeValue])
  //       }

  //       if (res.resource && res.resource.length > 0 && !this.utilService.isMobile()) {
  //         this.hitSecondaryDataSource(this.currentData['list'][0]);
  //       }
  //       else {
  //         this.currentData['selectedList'] = undefined
  //       }
  //     }, err => {
  //       this.loader.hideSpinner();
  //       console.error("Api gives Error", err);
  //     });
  //   }
  // }
  
  makeImageFromUrl(url) {
    let st_data = JSON.parse(JSON.stringify(this.currentData.selectedList));
    if(st_data && st_data.id){
      if(this.currentData.selectedList.id && this.currentData.required_data){
        let activeValueindex = this.currentData.required_data.indexOf(this.currentData.required_data.find(x => x.id == this.currentData.selectedList.id));
        this.activeValue = (activeValueindex == undefined ? 0 : activeValueindex);
      }
      super.makeImageFromUrl(url);
    }else{
      this.baseService.getFileByUrl(url, false).subscribe(res => {
        if(res){
          st_data.url = URL.createObjectURL(res);
          st_data.urlBlob = res;
          st_data.urlFileType = this.baseService.getExtensionbyMimeType(res.type);
          let f_name;
          if (st_data.prescriptionNo != undefined) {
            f_name = "Doc_" + st_data.prescriptionNo;
          } else {
            f_name = "Doc_" + this.baseService.generateID(4);
          }
          f_name += st_data.urlFileType;
          if (st_data.status == 'final') {
            let data = { ...st_data, ...{ uniqueFile: true, noSave: true, saveJson: true, s3_time: moment(st_data.g_creation_time).format("YYYY-MM-DD") } };
            if(st_data.id){
              f_name = st_data.id;
            }
            this.printService.uploadDownloadedData(res, f_name, 'template_assessment', data, this.authenticationService.getCurrentUser().user_id, "application/pdf", (res) => {
              if (res && res.resource && res.resource.length > 0){
                this.currentData.selectedList = res.resource[0].extra_data;
                this.currentData.selectedList.view_selected_config = {};
                this.currentData.selectedList.view_selected_config.type = 'pdf';
                this.currentData.selectedList.url = this.currentData.selectedList.path;
                this.setS3variableinMongo(st_data.id, true);
              }else{
                this.currentData.selectedList.urlFileType = st_data.urlFileType;
                this.currentData.selectedList.urlBlob = st_data.urlBlob;
                this.currentData.selectedList.url = st_data.url;
                this.currentData.selectedList.urlFileName = f_name;
                this.setS3variableinMongo(st_data.id, false);
              }
            });
          }
        }
        this.loader.hideSpinner();
      });
    }
  }

  // goNext() {
  //   this.pagination['page_no'] = this.pagination['page_no'] + 1;
  //   this.filter.filter = this.filter.pseudoFilter == '' ? this.filter.filter : this.filter.pseudoFilter;
  //   return this.getHistory(undefined, 'next');
  // }
  
  // populateForm(btn, config?, s_data?) {
  //   let args = "id:"+(this.currentData.selectedList.observation_id ? this.currentData.selectedList.observation_id : this.currentData.selectedList.id);
  //   this.getData('GET_OBSERVATION_DATA_BY_ID', args, 'observation', 'diagnostic', '', (data) => {
  //       if(data && data && data.length > 0 && data[0].status == "amended"){
  //         super.populateForm(btn, config, data[0]);
  //       }else if(!data){
  //         this.alerts.error("Addendum Period is over");
  //       }else{
  //         this.alerts.info("Addendum the template to edit");
  //       }
  //   });
  // }
  onButtonClicked(btn, userPrint?, entity?, clickEvent?){
    if(btn.action == 'popup_form' && btn.api_action == "definalize_template_assessment"){
      let args = "id:"+(this.currentData.selectedList.observation_id ? this.currentData.selectedList.observation_id : this.currentData.selectedList.id);
      this.getData('GET_BY_ID', args, 'observation_template_assessment', 'emr', '', (data) => {
          if(data && data && data.length > 0 && data[0].status == "amended"){
            this.alerts.info("Already in addendum stage");
            super.populateForm(btn, '', data[0]);
          }else if(!data){
            this.alerts.error("Addendum Period is over");
          }else{
            super.onButtonClicked(btn, userPrint, entity, clickEvent);
          }
      });
    }else{
      super.onButtonClicked(btn, userPrint, entity, clickEvent);
    }
  }
 
  // hitSecondaryDataSource(item, index?, show?, versionCheck?) {
  //   this.currentData.selectedList = item.extra_data ? item.extra_data : item;
  //   if (this.currentData.selectedList.path) {
  //     this.currentData.selectedList.view_selected_config = {};
  //     this.currentData.selectedList.view_selected_config.type = 'pdf';
  //     let url = this.baseService.getApiEndpoint("dms") + 'template_assessment' + '/image-response-entity?path=' + this.currentData.selectedList.path + '&application=dms';
  //     this.currentData.selectedList.url = undefined;
  //     this.baseService.getFileByUrl(url, false).subscribe((res: any) => {
  //       if(res){
  //         console.log("Url is ", res);
  //         this.currentData.selectedList.url = URL.createObjectURL(res);
  //         this.currentData.selectedList.urlBlob = res;
  //         this.currentData.selectedList.urlFileType = 'pdf';
  //         // this.currentData.selectedList.urlFileName = "Doc_" + list.prescriptionNo;
  //       }
  //     });
  //     if (this.currentData && this.currentData.resouceDef && this.currentData.resouceDef.config != undefined && this.currentData.resouceDef.config.definalize != undefined && !versionCheck ) {
  //       this.currentData['hideDropdown'] = false;
  //       this.currentData.versionVal = '';
  //       this.setVersionControl(this.currentData.selectedList);
  //     }else{
  //       this.currentData['hideDropdown'] = true;
  //     }
  //     if(this.currentData.selectedList.observation_id){
  //       let activeValueindex = this.currentData.required_data.indexOf(this.currentData.required_data.find(x => x.observation_id == this.currentData.selectedList.observation_id));
  //       this.activeValue = (activeValueindex == undefined ? 0 : activeValueindex);
  //     }
  //   }else{
  //     this.onClickSideList(this.currentData.selectedList);
  //   }
  //   if (this.currentData.scrollToView != undefined && this.currentData.scrollToView) { // scroll grid data to view
  //     setTimeout(() => { document.getElementById("scrollTestLab ").style.paddingTop = `${window.scrollY > 200 ? window.scrollY - 200 : 0}px`; });
  //   }
  // }

  // callMongoAPI(){
  //   if (this.currentData && this.currentData.resouceDef && this.currentData.resouceDef.list && this.currentData.resouceDef.list.APIresource && this.currentData.resouceDef.list.APIresource.mongoAPI) {
  //     let ds = this.currentData.resouceDef.list.APIresource.mongoAPI;
  //     let args = this.baseService.buildDyanamicStr(ds.args, { data: this.currentData['cardData'] });
  //     let filter = this.baseService.buildDyanamicStr(ds.filter, { data: this.currentData['cardData'] });
  //     var data = {
  //       args: args,
  //       page_no: this.pagination.page_no,
  //       page_size: this.pagination.page_size,
  //       filter: filter + (filter && this.filter && this.filter.filter ? "," : '') + this.filter.filter
  //     }
  //     if (this.currentData.ehr_view)
  //       data['read_scope_level'] = 'account';
  //     else if (data['read_scope_level'] != undefined)
  //       delete data['read_scope_level'];
  //     this.baseService.getData(data, "", ds.resource, ds.application, ds.query_id || ds.queryId).subscribe(res => {
  //       if(res && res.resource && res.resource.length > 0){
  //         this.currentData.list = [...this.currentData.list, ...res.resource];
  //         this.currentData['list'] = this.currentData['list'].sort(function(a, b){
  //           return b.g_creation_time - a.g_creation_time;
  //         })
  //         this.currentData.count  = this.currentData['list'].length;
  //         this.currentData.required_data = this.currentData['list'];
  //         if(this.currentData.selectedList == undefined)
  //           this.hitSecondaryDataSource(this.currentData['list'][0]);
  //       }
  //     });
  //   }
  // }

}
